import SectionLabel from "../common/SectionLabel";
import LeadershipItem from "./LeadershipItem";
import { leadership } from "../../data/leadership";

function Leadership() {
  return (
    <section id="leadership" className="divider">
      <div className="wrap">
        <SectionLabel label="leadership & volunteering" />
        <div className="experience-list">
          {leadership.map((item) => (
            <LeadershipItem item={item} key={item.slug} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Leadership;
